import React from 'react';
import { Switch } from '@mui/material';
import { GridCellParams } from '@mui/x-data-grid';
import { furnitureModStyles } from './FurnitureMod.styles';
import { selectIsEditMod } from 'store/redux-store/placement-mods/selectors';
import { useSelector } from 'react-redux';

const UtilityBillable = React.memo(function UtilityBillable(params: any) {
  const { classes } = furnitureModStyles({ isExpanded:false });
  const isModEdit = useSelector(selectIsEditMod);
  return (
    <div>
      <Switch checked={params?.row?.billable} className={isModEdit ? classes.switchPrimary : classes.switchLightBlue} />{' '}
      {params?.row?.billable ? 'Yes' : 'No'}
    </div>
  );
});

export const FurnitureUtility = (params: GridCellParams) => {  
  return <UtilityBillable {...params} />;
};
